export default {
    "1": "News",
    "2": "Exporting Files",
    "3": "Downloaded Information",
    "4": "Request Timeout",
    "5": "Request Exception",
    "6": "Abnormal Response",
    "7": "Nationwide",
    "8": "Beijing",
    "9": "Tianjin City",
    "10": "Hebei Province",
    "11": "Shanxi Province",
    "12": "Inner Mongolia Autonomous Region",
    "13": "Liaoning Province",
    "14": "Jilin Province",
    "15": "Heilongjiang Province",
    "16": "Shanghai City",
    "17": "Jiangsu Province",
    "18": "Zhejiang Province",
    "19": "Anhui Province",
    "20": "Fujian Province",
    "21": "Jiangxi Province",
    "22": "Shandong Province",
    "23": "Henan Province",
    "24": "Hubei province",
    "25": "Hunan Province",
    "26": "Guangdong Province",
    "27": "Guangxi Zhuang Autonomous Region",
    "28": "Hainan ",
    "29": "Chongqing City",
    "30": "Sichuan Province",
    "31": "Guizhou Province",
    "32": "Yunnan Province",
    "33": "Xizang Autonomous Region",
    "34": "Shaanxi Province",
    "35": "Gansu Province",
    "36": "Qinghai Province",
    "37": "Ningxia Hui Autonomous Region",
    "38": "Xinjiang Uygur Autonomous Region",
    "39": "Taiwan Province",
    "40": "Hong Kong Special Administrative Region",
    "41": "Macau Special Administrative Region",
    "42": "Rice",
    "43": "Create result labels",
    "44": "Acreage",
    "45": "Square Meter",
    "46": "Total Area",
    "47": "Your browser does not support sockets",
    "48": "Open a connection",
    "49": "Communication not ready, unable to send message",
    "50": "Communication Established",
    "51": "Connection Successful",
    "52": "Section",
    "53": "Attempt to reconnect",
    "54": "Connection Closed",
    "55": "Websocket Disconnect:",
    "56": "Second",
    "57": "Credit Evaluation",
    "58": "Execute Clear",
    "59": "Dragging to change position",
    "60": "Hold down the ALT key and drag up and down to change position",
    "61": "Drag to change position \\ nHold down ALT key and drag up and down to change position",
    "62": "Pick to non drag entities",
    "63": "Select the position of the dotted line and press the mouse:",
    "64": "The absolute height of the pressed point",
    "65": "Altitude:",
    "66": "Establish",
    "67": "Establishing a connection in the chat room",
    "68": "The chat room has been logged out",
    "69": "Flyable Zone",
    "70": "Positioning the airport",
    "71": "Horizontal Area",
    "72": "Linear Distance",
    "73": "Longitude",
    "74": "Latitude",
    "75": "Height",
    "76": "Nothing",
    "77": "Single point solution",
    "78": "Floating-point solution",
    "79": "Fixed Solution",
    "80": "Unknown",
    "81": "Initialization",
    "82": "During self inspection",
    "83": "Waiting for reset",
    "84": "Resetting",
    "85": "Standby",
    "86": "Preparing",
    "87": "Prepare for takeoff",
    "88": "In Progress",
    "89": "Returning",
    "90": "During Landing",
    "91": "Recycling",
    "92": "Battery Loading",
    "93": "Battery unloading in progress",
    "94": "Battery Loaded",
    "95": "Status Error",
    "96": "Waiting for confirmation",
    "97": "Maintenance Status",
    "98": "Receiving landing ready",
    "99": "Waiting for charging to restore power",
    "100": "Charging",
    "101": "Full",
    "102": "In Use",
    "103": "Battery not in place",
    "104": "Battery Silence",
    "105": "In battery communication",
    "106": "Battery communication failure",
    "107": "Excessive battery pressure difference",
    "108": "Charging Overcurrent",
    "109": "Charging over temperature",
    "110": "Forced charging in progress",
    "111": "North Wind",
    "112": "Northeast wind",
    "113": "Dongfeng",
    "114": "Southeast Wind",
    "115": "South Wind",
    "116": "Southwest Wind",
    "117": "Westerly",
    "118": "Northwest Wind",
    "119": "Disconnect",
    "120": "Unsupported Routes",
    "121": "Returning",
    "122": "Prepare to upload",
    "123": "Uploading",
    "124": "Prepare to execute",
    "125": "Download Photos",
    "126": "Task Paused",
    "127": "Task Start",
    "128": "Task Completed",
    "129": "Airport connection successful",
    "130": "Prompt",
    "131": "Console",
    "132": "Rocker:",
    "133": "Tilt:",
    "134": "Pitch:",
    "135": "Heading:",
    "136": "Please turn on the drone control switch",
    "137": "Pan tilt yaw",
    "138": "Gimbal Tilt",
    "139": "Above throttle lock",
    "140": "Drone control joystick successfully connected",
    "141": "Drone control throttle connection successful",
    "142": "Other Devices",
    "143": "Your browser does not support device connection",
    "144": "Topographic",
    "145": "Administrative",
    "146": "Ranging",
    "147": "Acreage",
    "148": "Please check the layer first",
    "149": "Right click on waypoint to perform individual deletion",
    "150": "Parameter configuration error, no waypoint in the area",
    "151": "The polygonal area is too large, please plan again",
    "152": "Right click to complete this side distance",
    "153": "Right click to complete this side view",
    "154": "Command",
    "155": "Data",
    "156": "Achievement",
    "157": "Software List",
    "158": "Tasks",
    "159": "Task Library",
    "160": "Route Library",
    "161": "Task Record",
    "162": "Process",
    "163": "Devices",
    "164": "Airport",
    "165": "Mobile Terminal ",
    "166": "Parts",
    "167": "Airport Version",
    "168": "Members",
    "169": "Team Members",
    "170": "System Settings",
    "171": "Chat Room",
    "172": "2D Tools",
    "173": "User Center",
    "174": "Current Map",
    "175": "Please select",
    "176": "Return",
    "177": "Frame",
    "178": "Flight Data",
    "179": "Aerocraft",
    "180": "Personnel",
    "181": "Second",
    "182": "Second",
    "183": "Flight Frequency",
    "184": "Flight time statistics",
    "185": "Flight Time",
    "186": "Flight Distance",
    "187": "No data available",
    "188": "This Week",
    "189": "Monday",
    "190": "Tuesday",
    "191": "Wednesday",
    "192": "Thursday",
    "193": "Friday",
    "194": "Saturday",
    "195": "Sunday",
    "196": "First Week",
    "197": "Second Week",
    "198": "Week 3",
    "199": "Fourth week",
    "200": "Week 5",
    "201": "Week 6",
    "202": "Platform",
    "203": "People",
    "204": "This area is currently not open!",
    "205": "The area is currently not open!",
    "206": "Hainan",
    "207": "Sales Volume",
    "208": "Frequency",
    "209": "Add",
    "210": "Delete",
    "211": "Please enter the name/device SN/device number",
    "212": "Region",
    "213": "Please select a region",
    "214": "Team",
    "215": "Model",
    "216": "Title",
    "217": "Cancel",
    "218": "Confirm",
    "219": "Pop-up Notification",
    "220": "Photo Viewing",
    "221": "Panoramic Photos",
    "222": "Num",
    "223": "There is currently no data available",
    "224": "Please enter search content",
    "225": "Save",
    "226": "Please enter the route name",
    "227": "Selecting Aircraft and Load",
    "228": "Load Setting",
    "229": "Please select a pan tilt device",
    "230": "Photo storage type settings",
    "231": "Estimated Flight Mileage",
    "232": "Estimated flight time",
    "233": "Number of waypoints",
    "234": "Photos",
    "235": "Set takeoff point",
    "236": "Takeoff Point",
    "237": "Delete takeoff point",
    "238": "Tilt up to the starting point",
    "239": "Safe takeoff altitude",
    "240": "\"Safe Takeoff Altitude\" is the altitude value relative to the takeoff point",
    "241": "After takeoff, the aircraft will first ascend to a safe takeoff altitude“",
    "242": "Fly back to the starting point of the route (S point)",
    "243": "Route altitude mode",
    "244": "Altitude",
    "245": "Ground Height",
    "246": "Speed",
    "247": "Aircraft yaw angle mode",
    "248": "Automatic: The aircraft's nose flies along the course direction to the next waypoint",
    "249": "Custom heading: During the flight of the aircraft to the next waypoint, users can manually control the orientation of the aircraft's nose",
    "250": "Locked perspective: The aircraft's nose maintains the yaw angle of the aircraft after completing the waypoint action and flies to the next waypoint",
    "251": "Efficient mode: During the process of flying to the next waypoint, the aircraft controls the heading set by the aircraft's nose towards the next waypoint while flying",
    "252": "Pan tilt angle control mode between waypoints",
    "253": "Manual control: During the flight of the aircraft from one waypoint to the next, it supports users to manually control the pitch angle of the gimbal; If there is no user control, maintain the pan tilt angle when flying away from the waypoint.",
    "254": "Custom control: During the flight of the aircraft from one waypoint to the next, the pitch angle of the gimbal transitions uniformly to the pitch angle of the next waypoint.",
    "255": "Manual Control ",
    "256": "Custom Control",
    "257": "Waypoint Route",
    "258": "Return Altitude",
    "259": "The flight altitude at which the aircraft returns to the takeoff point",
    "260": "Complete the action",
    "261": "Automatic return: After completing the aircraft's route mission, it immediately flies towards the takeoff point. If the aircraft is currently in a state of loss of control or loses control during the process of flying towards the takeoff point, immediately execute the loss of control action.",
    "262": "Hovering at the starting point of the return route: After the aircraft completes its route mission, it immediately flies towards the starting point (S point). If the aircraft is currently in a state of loss of control or loses control during the flight towards the starting point (S point), it immediately executes a loss of control action.",
    "263": "Exit route mode: After completing the aircraft route mission, immediately exit route mode and hover at the origin. If the aircraft is currently in a state of loss of control, immediately execute the loss of control action",
    "264": "Landing in place: Upon completion of the aircraft's flight path mission, the landing begins immediately. If the aircraft is currently in a state of loss of control or loses control during landing, immediately execute the loss of control action",
    "265": "Loss of control during flight",
    "266": "Out of control action",
    "267": "Return: The aircraft flies from an out of control position towards the takeoff point",
    "268": "Landing: The aircraft lands from an out of control position.",
    "269": "Hovering: The aircraft hovers from an out of control position.",
    "270": "Add Waypoint",
    "271": "Click here to create a waypoint for route planning",
    "272": "Don't prompt again",
    "273": "Search",
    "274": "Sign",
    "275": "Map Markers",
    "276": "Geographical Position",
    "277": "Please enter longitude",
    "278": "Please enter latitude",
    "279": "Annotation Information",
    "280": "Name",
    "281": "Please enter a name",
    "282": "Annotation Style",
    "283": "Icon",
    "284": "Confirm",
    "285": "Layer ",
    "286": "Please enter the layer name",
    "287": "Atlas",
    "288": "Measure",
    "289": "Enlarge",
    "290": "Narrow",
    "291": "Add Action",
    "292": "Gimbal",
    "293": "Aircraft actions",
    "294": "Hover",
    "295": "Aircraft yaw angle",
    "296": "Pan tilt action",
    "297": "Gimbal Yaw",
    "298": "Gimbal Tilt",
    "299": "Load Action",
    "300": "A stop en route",
    "301": "Follow the route",
    "302": "Relative height",
    "303": "Waypoint Type",
    "304": "Waypoint Action",
    "305": "Gimbal Angle",
    "306": "Take Photo",
    "307": "Start Recording",
    "308": "Stop Recording",
    "309": "Camera Zoom",
    "310": "Create Folder",
    "311": "Start Timed Interval Shot",
    "312": "Start Distance Interval Shot",
    "313": "End Interval Shot",
    "314": "Efficient Mode",
    "315": "Fly to the current waypoint yaw angle setting",
    "316": "Aircraft rotation direction",
    "317": "Problem",
    "318": "Returning will exit the route planning editor. Do you want to save it? If not saved, your changes will be lost",
    "319": "Do not save",
    "320": "After modifying the altitude mode, the route calculation method will change. Please check the route altitude value to ensure flight safety",
    "321": "If changing the altitude, please select whether the existing waypoints retain the altitude values of each waypoint or recalculate the altitude values of each waypoint based on the current altitude mode",
    "322": "Maintain waypoint altitude",
    "323": "Recalculate",
    "324": "Replacing the camera will affect the route operation parameters, please operate with caution",
    "325": "Please enter the route name!",
    "326": "This route belongs to an old version and does not support resaving",
    "327": "The number of waypoints cannot be less than 2!",
    "328": "Wide angle photo",
    "329": "Zoom Photos",
    "330": "Infrared Photo",
    "331": "Telephoto Photo",
    "332": "Visible light photo",
    "333": "Thermal imaging photos",
    "334": "Automatic",
    "335": "Custom Heading",
    "336": "Lock Perspective",
    "337": "Straight flight to point stop",
    "338": "No stop at waypoint",
    "339": "Coordinate Turns",
    "340": "Automatic Return",
    "341": "Landing in place",
    "342": "Hovering at the starting point of return flight",
    "343": "Exit route mode",
    "344": "Continue to execute the route",
    "345": "Execute out of control actions",
    "346": "Land",
    "347": "Absolute Height",
    "348": "Normal Waypoint",
    "349": "Starting Point",
    "350": "Clockwise",
    "351": "Counterclockwise",
    "352": "Successfully deleted the waypoint",
    "353": "Failed to delete the waypoint",
    "354": "New route construction",
    "355": "This route belongs to an old version and does not support re editing",
    "356": "Failed to obtain and edit route data",
    "357": "Group Chat",
    "358": "Announcement",
    "359": "View announcements by default when opening a chat room",
    "360": "Please enter the announcement",
    "361": "Joined the group",
    "362": "Receive Messages",
    "363": "The announcement content cannot be empty!",
    "364": "The maximum length of the announcement text is 100 words!",
    "365": "Function",
    "366": "Temperature",
    "367": "Humidity",
    "368": "Wind Speed",
    "369": "Rainfall",
    "370": "Wind Direction",
    "371": "Info",
    "372": "Please enter the airport name",
    "373": "Please enter the terminal name",
    "374": "Hangar",
    "375": "Terminal",
    "376": "Unassign",
    "377": "The item was not found",
    "378": "Video",
    "379": "Control",
    "380": "Airport Status",
    "381": "Task Progress",
    "382": "Current Task",
    "383": "Photo Upload Progress",
    "384": "View",
    "385": "Task Status",
    "386": "Aircraft Battery Level",
    "387": "Energy consumption information",
    "388": "Two point shooting task on the roof of Anjubao Building",
    "389": "Re Planning",
    "390": "Preview",
    "391": "Detail",
    "392": "Remove",
    "393": "Download",
    "394": "Task to be executed",
    "395": "Execution Time",
    "396": "Cancel Execution",
    "397": "The pending task is empty",
    "398": "Task Details",
    "399": "Task Name",
    "400": "Route Name",
    "401": "Task belongs to",
    "402": "Number of executions",
    "403": "Proposed Execution Time",
    "404": "Priority",
    "405": "Remote control disconnection strategy",
    "406": "RTK, GPS signals",
    "407": "Open",
    "408": "Close",
    "409": "Max Retries",
    "410": "Latest task execution time",
    "411": "Creator",
    "412": "Creation Time",
    "413": "Task Notes",
    "414": "Please enter the task name",
    "415": "Task List",
    "416": "-Task",
    "417": "Execute Tasks",
    "418": "The task list is empty",
    "419": "Anjubao rooftop two-point route",
    "420": "Please enter the flight record name",
    "421": "Photos",
    "422": "number",
    "423": "User",
    "424": "Task Progress",
    "425": "Task Duration",
    "426": "Branch",
    "427": "Flight record is empty",
    "428": "Fly Again",
    "429": "Starting Waypoint",
    "430": "Suspend",
    "431": "New Task",
    "432": "Route",
    "433": "Description",
    "434": "Please enter a task description",
    "435": "Execution reference time",
    "436": "Select Time",
    "437": "Latest Execution Time",
    "438": "Payload",
    "439": "There is currently no load device available for use",
    "440": "Audio Files",
    "441": "Loop",
    "442": "Please select an audio file",
    "443": "Choose Language",
    "444": "You can choose any three or fewer to play in TTS language",
    "445": "Speech Speed",
    "446": "Please enter the text content",
    "447": "Background Sound",
    "448": "Please select a background sound file",
    "449": "Load Route",
    "450": "Please select the starting waypoint for the load",
    "451": "Please select the end waypoint for the load",
    "452": "Search Light",
    "453": "Warning Light",
    "454": "Send to chat room",
    "455": "No fly zone",
    "456": "There is currently no area available",
    "457": "Height limit zone",
    "458": "Grid",
    "459": "Test",
    "460": "Duration",
    "461": "ASL",
    "462": "AGL",
    "463": "Distance",
    "464": "H.S",
    "465": "V.S",
    "466": "Pan tilt operation",
    "467": "Camera",
    "468": "Flight Instructions",
    "469": "Route Instructions",
    "470": "Aircraft Control",
    "471": "Restore Route",
    "472": "American Hand",
    "473": "Zoom",
    "474": "Take Photo",
    "475": "Take Video",
    "476": "Recording",
    "477": "Payload",
    "478": "One click panoramic view",
    "479": "Flyto",
    "480": "Terminate",
    "481": "Continue",
    "482": "Go Back",
    "483": "Close",
    "484": "Rod",
    "485": "Battery",
    "486": "Platform",
    "487": "Aircraft",
    "488": "Open",
    "489": "Open All",
    "490": "Close All",
    "491": "Expand X",
    "492": "Retract X",
    "493": "Expand Y",
    "494": "Retract Y",
    "495": "Replace",
    "496": "Reset",
    "497": "Recovery",
    "498": "Init",
    "499": "Extend",
    "500": "Retract",
    "501": "Insert Battery",
    "502": "Remove Battery",
    "503": "Battery Charging",
    "504": "Stop Charging",
    "505": "Drone Startup",
    "506": "Drone Shutdown",
    "507": "Diversion",
    "508": "Go Back",
    "509": "Preview",
    "510": "Route",
    "511": "Location",
    "512": "Remove",
    "513": "Task Panel",
    "514": "Operation log",
    "515": "Airport",
    "516": "Airworthiness conditions",
    "517": "Return Image",
    "518": "Task",
    "519": "Record",
    "520": "Offline",
    "521": "Online",
    "522": "Please select a route",
    "523": "Please select the execution reference time",
    "524": "Please select the latest execution reference time",
    "525": "Mandarin Female",
    "526": "Mandarin Male",
    "527": "Cantonese",
    "528": "Taiwanese Mandarin",
    "529": "English Male",
    "530": "English Female",
    "531": "Northeastern Dialect",
    "532": "Sichuan Dialect",
    "533": "Henan Dialect",
    "534": "Hunan Dialect",
    "535": "Shaanxi Dialect",
    "536": "Start executing the guidance flight mission",
    "537": "The current task status cannot be terminated",
    "538": "Release of X-bar",
    "539": "Tightening the X-bar",
    "540": "Y rod released",
    "541": "Y-pole tightening",
    "542": "Power On",
    "543": "Shutdown",
    "544": "Number",
    "545": "Reset all batteries",
    "546": "Confirm Execution",
    "547": "Operation?",
    "548": "Already",
    "549": "Canceled",
    "550": "The airport is not online",
    "551": "Please be cautious whether to enter manual control!",
    "552": "The drone remote control mode has been turned on",
    "553": "Exited drone remote control mode",
    "554": "Stop Sending",
    "555": "Visible light mode (zoom)",
    "556": "Infrared Mode",
    "557": "Dual light mode",
    "558": "Visible light mode (wide angle)",
    "559": "Are you sure you want to delete this task?",
    "560": "Delete Successful",
    "561": "Cancel Deletion",
    "562": "Whether to start execution",
    "563": "Start Execution",
    "564": "Cancel Successful",
    "565": "Removal Successful",
    "566": "Successfully added task",
    "567": "There is currently no streaming available",
    "568": "Pedestrian Tracking",
    "569": "Dispatch failed, exceeding maximum waypoint limit!",
    "570": "Delivery Successful!",
    "571": "To be issued",
    "572": "Upload Route",
    "573": "To be executed",
    "574": "Complete the route",
    "575": "Upload Images",
    "576": "Complete",
    "577": "Termination",
    "578": "Fail",
    "579": "Waiting for retry",
    "580": "Overtime",
    "581": "Continue the task",
    "582": "Stop Task",
    "583": "First",
    "584": "Delay",
    "585": "The airport is online now",
    "586": "The airport is offline",
    "587": "In the process of restoring the route",
    "588": "There is currently no data on the no fly zone",
    "589": "Temporarily unlimited high area data",
    "590": "There is currently no data available for flying zones",
    "591": "The starting waypoint cannot be greater than the ending waypoint!",
    "592": "The end waypoint cannot be less than or equal to the start waypoint!",
    "593": "Update Records",
    "594": "Type",
    "595": "Control End",
    "596": "Clever Calculation",
    "597": "State",
    "598": "Updating",
    "599": "Free",
    "600": "Refresh Version",
    "601": "Refresh",
    "602": "Updated Version",
    "603": "Online Updates",
    "604": "Please select the refresh type",
    "605": "Please select the type of online update",
    "606": "Airport Name",
    "607": "Update Time",
    "608": "Yu3 Simulator Test",
    "609": "Refresh Successful",
    "610": "Operation",
    "611": "Streaming Settings",
    "612": "Turn on recording",
    "613": "Log Management",
    "614": "Are you sure to delete the airport",
    "615": "Add Automatic Airport",
    "616": "Device Name",
    "617": "Device SN",
    "618": "Equipment Number",
    "619": "Task Count",
    "620": "Please select a data that needs to be deleted!",
    "621": "Are you sure to delete the aircraft",
    "622": "Add mobile terminal",
    "623": "Insurance Details",
    "624": "Are you sure you want to delete the device",
    "625": "Add accessory assets",
    "626": "Belonging Airport",
    "627": "The current browser version does not support it. Please upgrade your browser",
    "628": "Welcome To",
    "629": "Log In",
    "630": "Account",
    "631": "Password",
    "632": "Remember Password",
    "633": "New User?",
    "634": "Application for use",
    "635": "Version Number",
    "636": "Please enter your account number",
    "637": "Please enter password",
    "638": "Login Successful",
    "639": "Log Out",
    "640": "Account Settings ",
    "641": "Change Password",
    "642": "Flight Certificate",
    "643": "Exit Successful",
    "644": "Failed to obtain user information",
    "645": "Quadruple Layout",
    "646": "Eightfold Layout",
    "647": "Export",
    "648": "Import",
    "649": "Please enter your account or name",
    "650": "Role",
    "651": "Team",
    "652": "Modify",
    "653": "Reset password ",
    "654": "Viewing Certificates",
    "655": "Edit Information",
    "656": "Add Members",
    "657": "Are you sure to delete the selected organization? Once the data is deleted, it will not be recoverable. Please operate with caution",
    "658": "Are you sure to delete the selected personnel? Once the data is deleted, it will not be recoverable. Please operate with caution",
    "659": "Please select a data that needs to be deleted",
    "660": "Role",
    "661": "Team",
    "662": "Job ID",
    "663": "Name",
    "664": "Organization",
    "665": "Mobile phone number",
    "666": "Role List",
    "667": "Role Name",
    "668": "Please enter the role name",
    "669": "Permission Type",
    "670": "Administrators",
    "671": "Administrators can only create regular users and cannot create administrators",
    "672": "Regular Users",
    "673": "Super Administrator",
    "674": "Edit",
    "675": "Menu Name",
    "676": "Select All",
    "677": "Are you sure you want to delete this role? Once the data is deleted, it will not be recoverable. Please operate with caution",
    "678": "Please select permission level",
    "679": "Home Page",
    "680": "Menu",
    "681": "Data Statistics",
    "682": "Initial Map",
    "683": "Button",
    "684": "Video",
    "685": "Device List",
    "686": "Panel",
    "687": "Route Inquiry",
    "688": "Mount Control",
    "689": "Live Video",
    "690": "Function List",
    "691": "Map Conversion",
    "692": "Ruler",
    "693": "Inspection Data",
    "694": "Query",
    "695": "Paste",
    "696": "Modify Folder",
    "697": "Query Folder",
    "698": "Remove Folders",
    "699": "3D Layer ",
    "700": "Planning Cycle",
    "701": "Aircraft, Airport, Other",
    "702": "New Addition",
    "703": "Equipment Model Management",
    "704": "User List",
    "705": "Organizational management",
    "706": "Role Management",
    "707": "Certificate Management",
    "708": "Upload",
    "709": "Upload Certificate",
    "710": "Your current permissions are insufficient!",
    "711": "Add Role",
    "712": "Edit Role",
    "713": "Successfully Added",
    "714": "Modified Successfully",
    "715": "Please click the edit button before editing can proceed",
    "716": "Please enter the team name",
    "717": "View Team",
    "718": "Team Name",
    "719": "Team Level",
    "720": "Number of members",
    "721": "Team name cannot be empty",
    "722": "Are you sure to delete the selected task? Once the data is deleted, it will not be recoverable. Please operate with caution",
    "723": "New 2D Orthorectified 1",
    "724": "Camera Model",
    "725": "Height Mode",
    "726": "Pan tilt angle",
    "727": "Task completion action",
    "728": "No signal to exit the task",
    "729": "Point Coordinates",
    "730": "Hover at the starting point of the return route",
    "731": "Equidistant photography",
    "732": "Waiting for time to take photos",
    "733": "Absolute Altitude",
    "734": "Relative ground height",
    "735": "Regional Area",
    "736": "Expected number of photos taken",
    "737": "Flight Altitude",
    "738": "Takeoff Speed",
    "739": "Heading overlap rate",
    "740": "Lateral overlap rate",
    "741": "Hasselblad Type",
    "742": "Telephoto Type",
    "743": "Wide Angle",
    "744": "Long-focus",
    "745": "Jingwei M30 series",
    "746": "Zoom",
    "747": "Infrared",
    "748": "Yu2 Industry Advanced Edition",
    "749": "Visible light camera",
    "750": "Please reselect the camera model as its parameters do not match",
    "751": "Save Successful",
    "752": "Please plan your route before saving!",
    "753": "PC customization",
    "754": "System Log",
    "755": "System Name",
    "756": "System name cannot be empty",
    "757": "Font Size",
    "758": "Organization Name",
    "759": "The organization name cannot be empty",
    "760": "Area",
    "761": "Initial",
    "762": "Please select the initial region",
    "763": "Custom",
    "764": "Change Icon",
    "765": "Language",
    "766": "Half a year",
    "767": "One Year",
    "768": "Open areas cannot be closed at all!",
    "769": "The open area should include the existing initial area!",
    "770": "Please click the edit button!",
    "771": "Route Source",
    "772": "Route Type",
    "773": "Time",
    "774": "Select Date",
    "775": "Distribution",
    "776": "Rename",
    "777": "Route documents",
    "778": "Select File",
    "779": "File Name",
    "780": "Please enter the file name",
    "781": "Are you sure to delete the selected route",
    "782": "Please select a file to upload first",
    "783": "Please select a route type",
    "784": "Import Route",
    "785": "Size",
    "786": "Please select a data that needs to be exported!",
    "787": "Allocation Successful",
    "788": "Unassigned",
    "789": "The start time cannot be greater than the end time",
    "790": "The end time cannot be less than the start time",
    "791": "The file already exists",
    "792": "Upload Successful",
    "793": "The route name cannot be empty",
    "794": "Please enter the record number",
    "795": "Task Status:",
    "796": "Issued by:",
    "797": "Task:",
    "798": "Record ID",
    "799": "Start Time",
    "800": "End Time",
    "801": "Are you sure to delete the selected data? Once the data is deleted, it will not be recoverable. Please operate with caution",
    "802": "Please select at least one item for deletion",
    "803": "Planned Tasks",
    "804": "Region",
    "805": "Record",
    "806": "Task name cannot be empty",
    "807": "Zhifei Cloud",
    "808": "Settings",
    "809": "Surveillance Center",
    "810": "App Download",
    "811": "Android",
    "812": "Insufficient Permissions!",
    "813": "Folder",
    "814": "Copy",
    "815": "Add Folders",
    "816": "3D Model",
    "817": "File Type",
    "818": "Create a new folder",
    "819": "Successfully created folder",
    "820": "Failed to create folder",
    "821": "Drone monitoring records",
    "822": "Drone Streaming",
    "823": "External push flow",
    "824": "Internal push flow",
    "825": "Drone flight trajectory",
    "826": "Basic information of flight records",
    "827": "View Photos",
    "828": "Remarks",
    "829": "Equipment",
    "830": "Results of enforcement",
    "831": "Flight Duration",
    "832": "Flight Mileage",
    "833": "Issuing Time",
    "834": "Completion Time",
    "835": "Number of photos taken",
    "836": "Rainfall",
    "837": "Number of satellites",
    "838": "RTK Status",
    "839": "Aircraft Yaw",
    "840": "Battery Level",
    "841": "Waypoint Position",
    "842": "Not within the video time range",
    "843": "Please enter the software name",
    "844": "Type:",
    "845": "Software Name",
    "846": "Software Type",
    "847": "Confirm deletion of selected files",
    "848": "Confirm Removal",
    "849": "Version number is",
    "850": "Is it a software",
    "851": "Please select the data first before exporting it",
    "852": "Current Password",
    "853": "Password cannot be empty",
    "854": "New Password",
    "855": "Confirm Password",
    "856": "Confirm Modifications",
    "857": "Two passwords do not match",
    "858": "The new and old passwords cannot be the same",
    "859": "Password modification successful",
    "860": "Add Certificate",
    "861": "Adding Certificate",
    "862": "My Certificate",
    "863": "The certificate name cannot be empty",
    "864": "Validity Until",
    "865": "Upload Photos",
    "866": "Certificate cannot be empty",
    "867": "Modifying Certificate",
    "868": "Expired ",
    "869": "Expiring Soon",
    "870": "Validity period cannot be empty",
    "871": "The validity period has expired",
    "872": "Flight certificates cannot exceed four",
    "873": "Failed to add flight certificate",
    "874": "Successfully added flight certificate",
    "875": "Failed to add certificate",
    "876": "There is a certificate being modified, please wait",
    "877": "Existence",
    "878": "Failed to obtain certificate data",
    "879": "Failed to obtain certificate list",
    "880": "Failed to modify flight certificate",
    "881": "Successfully modified flight certificate",
    "882": "Successfully deleted flight certificate",
    "883": "Avatar",
    "884": "User Name",
    "885": "Enter one user name",
    "886": "Please enter your phone number",
    "887": "Region",
    "888": "Current Organization",
    "889": "I need to upload the certificate",
    "890": "Avatar modification successful",
    "891": "User name modification successful",
    "892": "User name modification failed",
    "893": "Mobile phone number successfully modified",
    "894": "Mobile number modification failed",
    "895": "Avatar modification failed",
    "896": "Please enter the correct 11 digit phone number",
    "897": "The username cannot be empty!",
    "898": "Please Enter",
    "899": "Name User",
    "900": "Unread",
    "901": "Read",
    "902": "Me",
    "903": "Completed Announcement",
    "904": "I mentioned you",
    "905": "New Messages",
    "906": "Send",
    "907": "Only images can be sent",
    "908": "Cannot send blank information",
    "909": "Input word limit is 200 words",
    "910": "Select Photos",
    "911": "Anjubao rooftop airport",
    "912": "Execution Time:",
    "913": "Other",
    "914": "User Certificate",
    "915": "Setting of alternate landing points",
    "916": "Longitude:",
    "917": "Latitude:",
    "918": "Longitude cannot be empty",
    "919": "Latitude cannot be empty",
    "920": "Successfully modified the alternate landing point",
    "921": "Real time shouting",
    "922": "Angle Adjustment",
    "923": "Load device does not exist",
    "924": "Activate the loudspeaker",
    "925": "Airport low power consumption",
    "926": "Voltage",
    "927": "Electricity consumption (percentage",
    "928": "Electricity level (kWh)",
    "929": "Battery charging current",
    "930": "Solar panel voltage",
    "931": "Solar panel current",
    "932": "Solar panel charging power",
    "933": "Load and charging status",
    "934": "Charging Power",
    "935": "Inverter Time",
    "936": "Current state of the machine",
    "937": "Inverted Voltage",
    "938": "Inverter Current",
    "939": "Inversion Frequency",
    "940": "Load Current ",
    "941": "Load active power",
    "942": "Load apparent power",
    "943": "Load rate",
    "944": "Temperature of heat sink A",
    "945": "Temperature of heat sink B",
    "946": "Battery charging hours on the same day",
    "947": "Battery discharge ampere hours on the same day",
    "948": "PV power generation on the same day",
    "949": "Electricity consumption on the day of load",
    "950": "Panorama",
    "951": "Photo",
    "952": "On/off Flow",
    "953": "Screen Projection",
    "954": "Switch playback source",
    "955": "Panel Control",
    "956": "Enable Streaming",
    "957": "Loading",
    "958": "Airport Offline",
    "959": "Successfully Loaded",
    "960": "Loading failed, please try again",
    "961": "Request Error",
    "962": "The video has not been successfully loaded yet",
    "963": "Search location name",
    "964": "Information",
    "965": "Warning",
    "966": "Airport Altitude",
    "967": "Current aircraft altitude",
    "968": "The current aircraft is relatively high",
    "969": "Flight Parameters",
    "970": "Target Longitude",
    "971": "Target Latitude",
    "972": "Behavior",
    "973": "Please select behavior",
    "974": "Please enter the pan tilt angle",
    "975": "Please enter the flight altitude (m)",
    "976": "Please enter the flight speed (m/s)",
    "977": "Please enter the heading",
    "978": "Finish up job",
    "979": "Please select the end action",
    "980": "Attention: The airport is currently in operation, and once issued, the current mission will be stopped and the aircraft will be pulled up towards the target point in place",
    "981": "Rice",
    "982": "Please ensure the safety of the target direction airspace and pay attention to flight safety",
    "983": "Execute Immediately",
    "984": "Pan tilt angle cannot be empty",
    "985": "Flight altitude cannot be empty",
    "986": "Flight speed cannot be empty",
    "987": "Heading cannot be empty",
    "988": "Pan tilt angle only allows numbers and decimal points",
    "989": "The first digit is 0, the second digit cannot be any other number",
    "990": "The first digit cannot be a decimal point",
    "991": "There can only be one decimal point",
    "992": "There can only be one negative sign",
    "993": "Pan tilt angle between -90~0",
    "994": "Flight altitude is only allowed to be numbers and decimal places",
    "995": "Flight altitude between 0 and 300",
    "996": "Flight speed is only allowed to be numbers and decimal places",
    "997": "Flight speed between 1 (m/s) and 15 (m/s)",
    "998": "Heading only allows numbers and decimal points",
    "999": "Heading between -180 and 180",
    "1000": "The longitude format is incorrect",
    "1001": "Incorrect latitude format",
    "1002": "Create Route",
    "1003": "Tilted Model",
    "1004": "Area Route",
    "1005": "Circular surveying and mapping",
    "1006": "Panoramic surveying and mapping",
    "1007": "3D surveying and mapping",
    "1008": "The image resources are being downloaded crazily",
    "1009": "Please select at least one item for download",
    "1010": "Download Successful",
    "1011": "Aircraft Information",
    "1012": "Aircraft Model",
    "1013": "RTK ready status",
    "1014": "Ready",
    "1015": "Not Ready",
    "1016": "Airport Information",
    "1017": "Battery Information",
    "1018": "Task Information",
    "1019": "4G Enhancement",
    "1020": "LTE",
    "1021": "Connection",
    "1022": "Connected",
    "1023": "Not connected",
    "1024": "Certification status",
    "1025": "Certified",
    "1026": "Unauthenticated",
    "1027": "LTE activation authentication",
    "1028": "Verified Mobile Number",
    "1029": "Certification remaining time",
    "1030": "Please enter your phone number",
    "1031": "Verification Code",
    "1032": "Please enter the verification code",
    "1033": "Obtain verification code",
    "1034": "Authentication",
    "1035": "Certification in progress",
    "1036": "The status information module has been opened",
    "1037": "The status information module has been disabled",
    "1038": "Please activate the drone before proceeding!",
    "1039": "Please enter the correct phone number",
    "1040": "Verification has been sent to your phone, please check carefully!",
    "1041": "Certification Successful",
    "1042": "Day",
    "1043": "Hour",
    "1044": "Minute",
    "1045": "First time login, please change your password",
    "1046": "Original Password",
    "1047": "Please enter the original password",
    "1048": "Please enter a new password",
    "1049": "Confirm Password",
    "1050": "Please enter the new password again",
    "1051": "The passwords entered twice are inconsistent",
    "1052": "The new password cannot be the same as the old password",
    "1053": "The original password cannot be empty",
    "1054": "The new password cannot be empty",
    "1055": "The length of the new password is between 8-20 digits",
    "1056": "Confirm password cannot be empty",
    "1057": "Change successful, please log in again",
    "1058": "Please enter the device name",
    "1059": "Please select the device model",
    "1060": "Please enter the device model",
    "1061": "Please select your region",
    "1062": "Please enter the device SN",
    "1063": "Please enter the device number",
    "1064": "Please select the team you belong to",
    "1065": "Airport Model",
    "1066": "Please select the region you are in",
    "1067": "Assign Airport",
    "1068": "Please select the assigned airport",
    "1069": "Prohibit input of Chinese and special characters",
    "1070": "Prohibit Chinese input",
    "1071": "Name of height restriction zone",
    "1072": "Name of no fly zone",
    "1073": "Please enter the height",
    "1074": "Radius",
    "1075": "Flyable zone radius",
    "1076": "Flyable zone altitude",
    "1077": "Grid Spacing",
    "1078": "Flyable zone grid spacing",
    "1079": "Basic information of mobile terminals",
    "1080": "Please enter the device number",
    "1081": "Region",
    "1082": "Current homework information",
    "1083": "Youfei Replacement Aircraft",
    "1084": "Flight control version",
    "1085": "Mount Type",
    "1086": "Final Task Name",
    "1087": "Last Task Time",
    "1088": "Streaming information",
    "1089": "Please enter the drone streaming address",
    "1090": "Please input FLV",
    "1091": "Please input RTC",
    "1092": "Basic airport information",
    "1093": "Get Location",
    "1094": "Facing",
    "1095": "Hardware Version",
    "1096": "Please enter the internal streaming address",
    "1097": "Please enter the external streaming address",
    "1098": "Basic information of accessory assets",
    "1099": "Model",
    "1100": "Successfully Obtained",
    "1101": "Prohibit input of Chinese and special characters",
    "1102": "The first digit cannot be a decimal point",
    "1103": "Latitude range: -90~90",
    "1104": "Longitude range: -180~180",
    "1105": "Height cannot be empty",
    "1106": "The height range should be between 100-10000 meters",
    "1107": "Generate at least three points",
    "1108": "Name cannot be empty",
    "1109": "Successfully added height restriction zone",
    "1110": "Successful addition of no fly zone",
    "1111": "The radius cannot be empty",
    "1112": "Grid spacing cannot be empty",
    "1113": "Grid range granularity is too large, please re-enter",
    "1114": "Line geometric objects",
    "1115": "Please draw a regular polygon!",
    "1116": "Successfully Added",
    "1117": "Right click to exit editing mode and delete",
    "1118": "Please Redraw",
    "1119": "Add Insurance",
    "1120": "Adding Insurance",
    "1121": "Insurance Name",
    "1122": "The insurance name cannot be empty",
    "1123": "Photo",
    "1124": "Insurance photos cannot be empty",
    "1125": "Modifying insurance",
    "1126": "The photo cannot be empty",
    "1127": "----Printing:",
    "1128": "Failed to obtain insurance list",
    "1129": "Insurance photos cannot exceed four",
    "1130": "Failed to add insurance",
    "1131": "Successfully added insurance",
    "1132": "There is insurance being modified, please wait",
    "1133": "Failed to obtain insurance data",
    "1134": "Failed to modify insurance",
    "1135": "Successfully modified insurance",
    "1136": "Successfully deleted insurance",
    "1137": "Type",
    "1138": "Get Logs",
    "1139": "Are you sure to delete this log",
    "1140": "Get Time",
    "1141": "Get Logs",
    "1142": "Log acquisition successful",
    "1143": "There are currently no logs of this type available",
    "1144": "There are currently no logs of this type!",
    "1145": "Are you sure to delete this streaming",
    "1146": "Increase",
    "1147": "Streaming Name",
    "1148": "Address",
    "1149": "FLV Port",
    "1150": "RTC Port",
    "1151": "API Port",
    "1152": "Video",
    "1153": "Play Source",
    "1154": "RTC Pause",
    "1155": "Loading failed, please try again 1",
    "1156": "RTC Start",
    "1157": "RTC Full Screen",
    "1158": "RTC Mute",
    "1159": "Rtc Unmute",
    "1160": "RTC playback currently does not support screenshots",
    "1161": "RTC currently does not support recording",
    "1162": "RTC Cancel Recording",
    "1163": "Video",
    "1164": "Airports",
    "1165": "Modify Organization",
    "1166": "Add Organization",
    "1167": "Please enter the organization name",
    "1168": "The length of the organization name should be within 20 characters",
    "1169": "Add Team",
    "1170": "The team name should be within 10 characters in length",
    "1171": "Please select an organization",
    "1172": "Please select a role",
    "1173": "Please enter the job number",
    "1174": "Member Import",
    "1175": "Please select the import file",
    "1176": "Please enter the material name",
    "1177": "User Name",
    "1178": "User Role",
    "1179": "Prompt Information",
    "1180": "Resetting member passwords is a permission operation. To ensure that you have the permission to reset member passwords, please enter the password of your current login account",
    "1181": "Reset Successful",
    "1182": "Control Module ",
    "1183": "The modified content cannot be empty",
    "1184": "Route Info",
    "1185": "Task Name:",
    "1186": "Total number of waypoints",
    "1187": "Photo Points",
    "1188": "Length",
    "1189": "Top Speed",
    "1190": "Estimated Time",
    "1191": "Task End Mode",
    "1192": "Out of Control",
    "1193": "Heading Mode ",
    "1194": "Put it away",
    "1195": "Launch",
    "1196": "Shoot",
    "1197": "Yes",
    "1198": "No",
    "1199": "Import File",
    "1200": "Please select a file type",
    "1201": "File Naming",
    "1202": "Layer Files",
    "1203": "Photo Files",
    "1204": "Checking if the file has been uploaded",
    "1205": "Non image format files can only select other files",
    "1206": "Slice upload retry",
    "1207": "Upload file failed",
    "1208": "Failed to upload slices",
    "1209": "An error occurred in a shard upload request",
    "1210": "Reason for error",
    "1211": "File save failed",
    "1212": "The version file is currently being uploaded. Please choose to continue uploading in the background or cancel the upload",
    "1213": "Backend Upload",
    "1214": "Abandon Uploading",
    "1215": "Background upload has been executed, please do not close the system or refresh the page",
    "1216": "Uploaded Canceled",
    "1217": "Please select a layer file",
    "1218": "The file has not been checked yet. Please wait",
    "1219": "Please enter the version number",
    "1220": "File",
    "1221": "Save Failed",
    "1222": "Save failed, reason for failure:",
    "1223": "The software file is currently being uploaded. Please choose to continue uploading in the background or cancel the upload",
    "1224": "Please select a file",
    "1225": "File Md5 is empty, please reselect",
    "1226": "Format",
    "1227": "Open",
    "1228": "Please select the file data to be deleted",
    "1229": "Do not select both folder and data at the same time",
    "1230": "Are you sure to delete the selected file?",
    "1231": "Successfully deleted data",
    "1232": "Renaming Successful",
    "1233": "Renaming Failed",
    "1234": "Successfully modified photo type",
    "1235": "Please select the data or folder to be deleted",
    "1236": "The folder is not replicable",
    "1237": "Please select the data to be copied",
    "1238": "Please select the data to be replicated again",
    "1239": "Selected data has been copied",
    "1240": "Please select data for replication first",
    "1241": "Paste Successful",
    "1242": "The folder cannot be exported",
    "1243": "Picture Details",
    "1244": "Photography Point",
    "1245": "Batch Download",
    "1246": "Please enter the plan name",
    "1247": "New Plan",
    "1248": "Every Day",
    "1249": "Start-up",
    "1250": "Please enter a description of the planned task",
    "1251": "Select Task",
    "1252": "Execution Cycle",
    "1253": "Period of validity",
    "1254": "Weekly",
    "1255": "Monthly",
    "1256": "Date",
    "1257": "Plan Name",
    "1258": "Homework Cycle",
    "1259": "Validity Period",
    "1260": "On State",
    "1261": "Plan Remarks",
    "1262": "Please enter a description note",
    "1263": "Please select a task",
    "1264": "Please select the execution cycle",
    "1265": "Please select the start date",
    "1266": "Please select the end date",
    "1267": "Please select the execution time",
    "1268": "The cycle parameter cannot be empty",
    "1269": "Are you sure to delete the selected plan? Once the data is deleted, it will not be recoverable. Please operate with caution",
    "1270": "The selected task contains tasks that are currently being started. Please reselect them",
    "1271": "Successfully Started",
    "1272": "Paused",
    "1273": "Unable to remove during task initiation",
    "1274": "New plan successfully created",
    "1275": "Please select a time",
    "1276": "Last execution time of the task",
    "1277": "Please enter task notes",
    "1278": "Sequential Extension",
    "1279": "Please select a reference execution time",
    "1280": "Please select a priority",
    "1281": "Please select a disconnection strategy",
    "1282": "Please choose whether to enable RTK and GPS signal",
    "1283": "Please select the maximum number of retries",
    "1284": "Please select the last execution time of the task",
    "1285": "Pan tilt linkage",
    "1286": "Play All",
    "1287": "Single does not loop",
    "1288": "Single Loop",
    "1289": "List does not loop",
    "1290": "List Loop",
    "1291": "Play",
    "1292": "Topping",
    "1293": "Unknown Author",
    "1294": "Audio file playback has been issued",
    "1295": "Distributed to play all",
    "1296": "Currently only supports uploading MP3 files",
    "1297": "Uploaded",
    "1298": "Removed",
    "1299": "Background music status",
    "1300": "Playing",
    "1301": "Idle ",
    "1302": "volume",
    "1303": "Background sound playback has been issued",
    "1304": "Mount Model",
    "1305": "Mount Status",
    "1306": "Speaker Status",
    "1307": "The device is offline",
    "1308": "Previous Song",
    "1309": "Next Song",
    "1310": "Terminate all playback",
    "1311": "Playback Ended",
    "1312": "Upgrading Firmware",
    "1313": "Starting",
    "1314": "Audio Frequency",
    "1315": "4g Shouting",
    "1316": "Analog Signal",
    "1317": "Play source information processing function",
    "1318": "Failed to start real-time shouting",
    "1319": "No audio stream obtained",
    "1320": "Real time call has been issued",
    "1321": "Your browser currently does not support recording",
    "1322": "Authorization failed!",
    "1323": "Burst Switch",
    "1324": "Operation successful",
    "1325": "No Loop",
    "1326": "Multiple",
    "1327": "Language",
    "1328": "Language",
    "1329": "You can freely choose 3 or fewer for TTS language playback",
    "1330": "Please choose one of the following languages for TTS language playback",
    "1331": "TTS records",
    "1332": "Speech Speed:",
    "1333": "Language:",
    "1334": "Loop Method:",
    "1335": "Loop Mode",
    "1336": "Currently, only 20 records can be displayed",
    "1337": "Version Update",
    "1338": "Select Version",
    "1339": "Replace",
    "1340": "Do you want to force an update to the online version",
    "1341": "User",
    "1342": "Version Type",
    "1343": "Please enter the version name",
    "1344": "Version Name",
    "1345": "Please select at least one version",
    "1346": "Time",
    "1347": "To",
    "1348": "Please select a date",
    "1349": "Please select the type",
    "1350": "Please select a time period",
    "1351": "The start date must be before the end date",
    "1352": "The end date must be later than the start date",
    "1353": "Please enter the streaming name",
    "1354": "Push flow path",
    "1355": "Please enter the streaming path",
    "1356": "Example",
    "1357": "Play Path",
    "1358": "Please enter the playback path",
    "1359": "Playback path format error",
    "1360": "Unable to input Chinese",
    "1361": "Data not modified, no need to submit",
    "1362": " Devices",
    "1363": " Terminals",
    "1364": "Please enter the safe flight altitude",
    "1365": "Platform docking",
    "1366": "Push airport information",
    "1367": "Through authorization",
    "1368": "Revoke authorization",
    "1369": "Automatic authorization for drone control",
    "1370": "Automatic authorization for drone takeoff",
    "1371": "Remember the authorization status and do not prompt again",
    "1372": "Requesting",
    "1373": "Take off permission",
    "1374": "Remote control permissions for",
    "1375": "Cancel authorization successful",
    "1376": "Confirm successful authorization"

}